import * as xmljs from "xml-js";

import { Xml2JsonParser } from "../../data/protocols/xml-parser/xml-2-json-parser";

export class Xml2JsonParserImplementation implements Xml2JsonParser {
  parse(xmlString: string): string {
    const options = { compact: true, ignoreComment: true, spaces: 4 };
    return xmljs.xml2json(xmlString, options);
  }
}
